import React from "react";
import Footer from "../../components/reuseables/Footer";
import Projects from "./components/Projects";

function OurWorks({ datas, webData }) {
  return (
    <div>
      <Projects datas={datas} webData={webData} />
				<Footer/>
    </div>
  );
}

export default OurWorks;
